<div class="add-location" [formGroup]="addLocationsFormGroup">
  <app-popup-top-line></app-popup-top-line>
  <div class="add-location-header">
    <div class="title">
      {{ 'policyPage.config.sensitiveLocationsContent.addLocationDialogTitle' | labelsProvider }}
    </div>
    <img style="cursor: pointer" src="assets/images/common/cancel.svg" (click)="onClose()" />
  </div>
  <div class="add-location-body" formArrayName="locationsToAdd">
    <div class="section-title" *ngIf="locationsToAdd.length > 0">New Locations to Add</div>
    <div
      class="location-input-container"
      *ngFor="let control of locationsToAdd.controls; let i = index"
      [formGroupName]="i"
    >
      <div class="input" [class.input-invalid]="control.get('location')?.invalid && control.get('location')?.touched">
        <input
          type="text"
          formControlName="location"
          placeholder="{{ 'policyPage.config.sensitiveLocationsContent.enterLocation' | labelsProvider }}"
        />
        <img *ngIf="i > 0" src="assets/images/common/cancel.svg" (click)="removeLocation(i)" />
      </div>
      <div class="error-message" *ngIf="control.get('location')?.invalid && control.get('location')?.touched">
        {{ getLocationErrorMessage(control.get('location')!) }}
      </div>
    </div>

    <div class="add-location-actions">
      <div class="add-more" (click)="addMoreClicked()">
        <img class="add-more-img" src="assets/images/common/plus.svg" />
        <div class="add-location-button-title">
          {{ 'policyPage.config.sensitiveLocationsContent.addMore' | labelsProvider }}
        </div>
      </div>
    </div>
  </div>
  <div class="add-location-footer">
    <button class="cancel" (click)="onClose()">
      {{ 'common.cancel' | labelsProvider }}
    </button>
    <button
      class="confirm"
      [ngClass]="{
        'confirm-disabled': addLocationsFormGroup.invalid || waitingForResponse,
      }"
      [disabled]="addLocationsFormGroup.invalid || waitingForResponse"
      (click)="addLocations()"
      cdkFocusInitial
    >
      <span *ngIf="!waitingForResponse">{{ 'common.add' | labelsProvider }}</span>
      <mat-progress-spinner class="spinner" *ngIf="waitingForResponse" color="primary" mode="indeterminate">
      </mat-progress-spinner>
    </button>
  </div>
</div>
